import React from 'react';

const DeleteAccount = () => {
    return (
        <div className="top-advisors-area pd-top-120 pd-bottom-90">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    <div className="section-title text-center">
                        {/* <h6 className="sub-title split_chars"></h6> */}
                        <h2 className="title move-line-3d">Delete Account</h2>
                        {/* <img className="mt-3" src="assets/img/icon/shalep-1.avif" alt="img"/> */}
                    </div>
                </div>
            </div>
                <div>
                    <div className="container d-flex justify-content-center"><div className="rounded-bottom">
                        <p className="text-secondary m-0"> Disclaimers : Request to before deleting your account please read the provided description in the page.</p>
                        <p><strong>Last updated:</strong> Dec 2025</p><ul><li>Deleting your account is a permanent action and cannot be undone. All your data will be removed from our system..</li><li>We may use the data collected to perform our legal or contractual obligations, as otherwise permitted by law or as.</li><li>And when requested by legal, regulatory, or investigatory authorities.</li><li> When you request deletion of your personal data, we will use reasonable efforts to honor your request.</li><li>In some cases, we may be legally required to keep some of the data for a certain time</li><li>And we will fulfill your request after we have complied with our obligations.</li> </ul>
                        <p className="text-secondary m-0"><strong>When you delete your account:</strong></p>
                        <ul>
                            <li>You will no longer be able to log in to this account.</li>
                            <li>You will lose access to your progress, statistics, and history.</li>
                            <li>Before deleting, ensure you are ready to lose your account.</li>
                            <li>For support & contact: <a href="mailto:info@cges.club" style={{color:"#ff810e"}}>info@cges.club</a></li>
                        </ul>
                    </div>
                    </div>
                </div>
            </div>
    </div>
    );
};

export default DeleteAccount;